import { render, staticRenderFns } from "./LoginSuperAdminConfirm.vue?vue&type=template&id=5b898301&"
import script from "./LoginSuperAdminConfirm.vue?vue&type=script&lang=js&"
export * from "./LoginSuperAdminConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports